import React from 'react';

import { Box, Button, CircularProgress } from '@mui/material';

import AxlDialog from '../AxlDialog';

const styles = {
  btnCancel: {
    backgroundColor: '#fff',
    color: '#4a4a4a',
    minWidth: '120px',
    border: '1px solid #4a4a4a',
  },
  btnSave: {
    backgroundColor: '#75c31e',
    color: '#fff',
    minWidth: '120px',
    border: '1px solid #75c31e',
    '&:hover': {
      backgroundColor: '#5a9a17',
      cursor: 'pointer',
    },
    '&:disabled': {
      backgroundColor: '#c8e6b3',
      borderColor: '#c8e6b3',
      color: '#fff',
      cursor: 'not-allowed',
      opacity: 0.7,
    },
  },
};

function AxlModalConfirm({
  alignTitle,
  isOpen,
  maxWidth,
  componentTitle,
  componentChildren,
  componentAction,
  handleClose,
  handleOK,
  textCancel,
  textOK,
  isSaving,
  customStyleCancel,
  customStyleSave,
}) {
  return (
    <AxlDialog
      alignTitle={alignTitle || 'center'}
      isOpen={isOpen}
      childrenTitle={componentTitle || 'CONFIRMATION'}
      maxWidth={maxWidth || 'sm'}
      handleClose={handleClose}
      childrenAction={
        componentAction || (
          <Box display="flex" justifyContent="flex-end" px={1} style={{ gap: 8 }}>
            <Button onClick={() => handleClose?.()} disabled={isSaving} variant="outlined" size="small" sx={{ ...styles.btnCancel, ...customStyleCancel }}>
              {textCancel || 'Cancel'}
            </Button>
            <Button onClick={() => handleOK?.()} variant="contained" disabled={isSaving} size="small" sx={{ ...styles.btnSave, ...customStyleSave }}>
              {isSaving && <CircularProgress size={20} />}
              {!isSaving && (textOK || 'Save')}
            </Button>
          </Box>
        )
      }
    >
      {componentChildren}
    </AxlDialog>
  );
}

export default AxlModalConfirm;
